import { memo } from 'react';

import DiffEditor from './DiffEditor';

export * from './types';

export default memo(DiffEditor);
